import type { RenderAssets } from "@karrtopelka/cards/render-client";

/**
 * Fetch + memoize the card-render assets (Inter 400/700 + resvg wasm) from the app's
 * own served static files. Loaded lazily only when the user opts to make a card, so it
 * never slows the game itself. Memoized — fetched once per page.
 */
let cache: Promise<RenderAssets> | null = null;

async function load(): Promise<RenderAssets> {
  const [fontRegular, fontBold, resvgWasm] = await Promise.all([
    fetch("/fonts/sans-regular.ttf").then((r) => r.arrayBuffer()),
    fetch("/fonts/sans-bold.ttf").then((r) => r.arrayBuffer()),
    fetch("/resvg.wasm").then((r) => r.arrayBuffer()),
  ]);
  return { fontRegular, fontBold, resvgWasm };
}

export function loadCardAssets(): Promise<RenderAssets> {
  return (cache ??= load());
}
